import React from "react";
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useEffect, useState } from "react";
import { useAppServices } from "hook/services";
import { Link, useNavigate } from "react-router-dom";
import { useAgencyInfo } from "context/agency";
import Loader from "examples/Loader";
import Grid from "@mui/material/Grid";
// import { Card, FormControlLabel, Icon, Slider, Switch, TextField, ToggleButton } from "@mui/material";
// import SoftTypography from "components/SoftTypography";
// import SoftButton from "components/SoftButton";
import CreateModal from "./components/CreateModal/index";
import "./style.css"
import ConfigrationForm from "./components/configration";
import NormalTable from "./NormalTable";
import { Button } from "@mui/material";
const Pricing = ({ data, potentialproducts, handleRefresh }) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false)
  // const [products, setproducts] = useState(data)
  const [prices, setPrices] = useState([])
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [open, setOpen] = useState(false)
  const [editModalopen, setEditModalopen] = useState(false)
  const [editModaldata, setEditModaldata] = useState(false)

  const [openModal, setopenModal] = useState(false)
  const [editdata, seteditdata] = useState()
  const handleClose = () => {
    setOpen(false);
    setEditModalopen(false);
  }
  const openeditsaasmodel = (data) => {
    setopenModal(true);
    seteditdata(data);
  }
  const openModal_getId = (item) => {
    setEditModaldata(item)
    setEditModalopen(true);
  }
  const handleCreateAccounts = async (product_id) => {
    const payload = {
      product_id: product_id
    }
    const { response } = await AppService.saas.create_accounts({ payload });
  }
  const handleRefereshpricing = () => {
    setEditModalopen(false)
    setEditModaldata(false)
    seteditdata(false)
    seteditdata(false)
    setOpen(false)

  }
  return (<>
    <Grid container>
      <Grid item xs={12}>

      <Grid style={{marginBottom:"20px"}} item xs={12} display="flex" justifyContent="flex-end">
            <Button
              style={{ background: "black", color: "white" }}
              variant="contained"
              onClick={() => setOpen(true)}
            >
              Add Plan
            </Button>
          </Grid>

        <SoftBox >
          <NormalTable data={data} potentialproducts={potentialproducts} openeditsaasmodel={openeditsaasmodel} handleCreateAccounts={handleCreateAccounts} handleRefresh={handleRefresh}/>
        </SoftBox >

      </Grid>
      {openModal &&
        <div className="modal-zz-confirm">

          <div className="scrollable-modal-content bg-white  rounded" style={{ position: "relative" }}>
            <h2 className='text-black text-left font-14'> Edit Saas : {editdata?.product_name}
            </h2>
            <span className='crossison' onClick={() => setopenModal(false)}>X</span>
            {/* Edit modal  */}
            <ConfigrationForm data={data} editdata={editdata} onClose={() => setopenModal(false)} handleRefereshpricing={handleRefereshpricing} handleRefresh={handleRefresh} />

          </div>
        </div>}

      {/* //CREATE MODAL  */}
      <CreateModal open={open} onClose={handleClose} prices={prices} handleRefresh={handleRefresh} data={data} />
      {/* <EditsaasModal open={editModalopen} onClose={handleClose} data={editModaldata} handleRefresh={handleRefresh} /> */}

    </Grid>
  </>)
}
export default Pricing